// src/components/GalleryTransmissionCard.jsx
// Tableau de bord : point d'entrée de la page « Continuité et transmission de la galerie ».
// Visible pour un compte galerie (profiles.gallery_mode, réglé par l'administration), ou pour un compte qui a déjà une
// collection de nature « archives de galerie » ou « estate d'artiste ». Un collectionneur ordinaire ne le voit pas.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../context/AuthContext";

const COPY = {
  fr: { eyebrow: "Galerie", title: "Continuité et transmission", body: "Mesurez où en est la préparation de vos archives, de vos œuvres et de leur histoire pour un passage de relais, une cession ou un estate.", cta: "Ouvrir" },
  en: { eyebrow: "Gallery", title: "Continuity and transmission", body: "See how far your archives, artworks and their history are prepared for a handover, a sale of the business or an estate.", cta: "Open" },
  de: { eyebrow: "Galerie", title: "Kontinuität und Übertragung", body: "Sehen Sie, wie weit Ihre Archive, Werke und deren Geschichte für eine Übergabe, einen Verkauf der Galerie oder einen Nachlass vorbereitet sind.", cta: "Öffnen" },
};

export default function GalleryTransmissionCard() {
  const { user, profile } = useAuth();
  const { i18n } = useTranslation();
  const c = COPY[String(i18n?.resolvedLanguage || i18n?.language || "fr").slice(0, 2)] || COPY.fr;
  const [on, setOn] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!user?.id) return undefined;
    (async () => {
      const { data } = await supabase
        .from("collections").select("id").eq("client_id", user.id)
        .in("ensemble_nature", ["gallery_archive", "artist_estate"]).limit(1);
      if (alive) setOn((data || []).length > 0);
    })().catch(() => {});
    return () => { alive = false; };
  }, [user?.id]);

  if (!on && profile?.gallery_mode !== true) return null;
  return (
    <div className="bg-white rounded-lg shadow p-5 mb-6 border border-gray-100">
      <p className="text-xs uppercase tracking-widest text-gray-500 mb-1">{c.eyebrow}</p>
      <h3 className="text-lg font-semibold text-gray-900 mb-1" style={{ fontFamily: "Georgia, serif" }}>{c.title}</h3>
      <p className="text-sm text-gray-600 mb-3">{c.body}</p>
      <Link to="/galeries/transmission" className="inline-block rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800">{c.cta}</Link>
    </div>
  );
}
